import OAuthIntegration from './OAuthIntegration';

export default class LinkedInIntegration extends OAuthIntegration {}
